<script>
import baseMixin from '@/mixins/baseMixin'
import BaseTreeSelector from '@components/general/base-tree-selector.vue'
import { mapActions } from 'vuex'
import { isArrayOfType, isNullOrEmptyArray } from '@helpers/array-helpers'

export default {
  name: 'LocationSelector',
  components: { BaseTreeSelector },
  mixins: [baseMixin],
  props: {
    adminIds: {
      type: Array,
      required: true,
    },
  },
  data: () => {
    return {
      loading: false,
      treeData: [],
      selectedLocations: [],
    }
  },
  watch: {
    adminIds: {
      deep: true,
      immediate: true,
      async handler() {
        await this.getTree()
        this.selectedLocations = []
      },
    },
  },
  methods: {
    ...mapActions({
      loadLocationsByAdminId: 'staff/loadAdminClientTree',
    }),
    async getTree() {
      if (
        isNullOrEmptyArray(this.adminIds) ||
        !isArrayOfType(this.adminIds, 'string')
      ) {
        this.treeData = []
        return
      }

      this.loading = true
      const res = await this.loadLocationsByAdminId(this.adminIds)
      // we don't need to show the admin level if only 1 admin
      if (res.data?.length === 1) {
        this.treeData = res.data.flatMap((n) => n.children)
      } else {
        this.treeData = res.data
      }
      this.loading = false
    },
    handleSave(locationNodes) {
      this.selectedLocations = locationNodes
      this.$emit(
        'save',
        locationNodes
          .filter((n) => n.level === 'Location')
          .map((n) => {
            return { id: n.id, title: n.title }
          })
      )
    },
    clearSelection() {
      this.selectedLocations = []
    },
  },
}
</script>

<template>
  <BaseTreeSelector
    ref="tree"
    :tree-data="treeData"
    :loading="loading"
    :selected="selectedLocations"
    prepend-icon-inner="mdi-map-marker-plus"
    :title="$t('locationSelector.title')"
    selectable
    searchable
    select-preview
    @save="handleSave"
  />
</template>
